export default "__VITE_ASSET__CB5gOCZ8__"